<template>
  <div class="new-user-page">
    <div class="banner">
      <div class="banner-content">
        <h1 class="banner-title">Create a new user</h1>
      </div>
      <div class="banner-decoration" aria-hidden="true">
        <div class="deco-circle deco-1"></div>
        <div class="deco-circle deco-2"></div>
        <div class="deco-circle deco-3"></div>
      </div>
    </div>

    <div class="login-container">
      <div class="login-card">
        <button type="button" class="btn-back" @click="goBack">
          <i class="fa fa-arrow-left"></i>
          Back
        </button>

        <form method="POST" @submit.prevent="signup">
          <div class="form-group">
            <label class="form-label">Username</label>
            <input
              type="text"
              class="form-input"
              v-model="username"
              required
            />
          </div>

          <div class="form-group">
            <label class="form-label">E-Mail Address</label>
            <input
              type="email"
              class="form-input"
              v-model="email"
              required
            />
          </div>

          <div class="form-group">
            <label class="form-label">Password</label>
            <input
              type="password"
              class="form-input"
              v-model="password"
              required
            />
          </div>

          <button type="submit" class="btn-primary">Create user</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { SIGNUP_MUTATION } from '@/graphql'

export default {
  name: 'NewUser',
  data () {
    return {
      username: '',
      email: '',
      password: ''
    }
  },
  methods: {
    goBack () {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/papers/search')
      }
    },
    signup () {
      this.$apollo
        .mutate({
          mutation: SIGNUP_MUTATION,
          variables: {
            username: this.username,
            email: this.email,
            password: this.password
          }
        })
        .then(() => {
          this.$router.replace('/login')
        })
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');

.new-user-page {
  font-family: 'Poppins', sans-serif;
  background: #f8fbf9;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.banner {
  background-color: #1b3d2f;
  border-radius: 0 0 12px 12px;
  padding: 3rem 2.5rem;
  position: relative;
  overflow: hidden;
}

.banner-content {
  position: relative;
  z-index: 2;
}

.banner-title {
  color: #ffffff;
  font-size: 36px;
  font-weight: 800;
  line-height: 1.2;
  margin: 0;
}

.banner {
  background-image: url('../../assets/banner.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
}

.banner::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(27, 61, 47, 0.82);
  border-radius: 0 0 12px 12px;
  z-index: 1;
}

.banner-content, .banner-decoration {
  position: relative;
  z-index: 2;
}

.banner-decoration {
  position: absolute;
  top: 0;
  right: 0;
  width: 260px;
  height: 100%;
  z-index: 1;
}

.deco-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.deco-1 {
  width: 200px;
  height: 200px;
  top: -60px;
  right: -40px;
}

.deco-2 {
  width: 140px;
  height: 140px;
  top: 20px;
  right: 100px;
}

.deco-3 {
  width: 80px;
  height: 80px;
  bottom: -20px;
  right: 60px;
}

.login-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.login-card {
  background: #ffffff;
  border: 1px solid #d5e8db;
  border-radius: 10px;
  padding: 2.5rem;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.login-heading {
  font-size: 22px;
  font-weight: 700;
  color: #1b3d2f;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 18px;
}

.form-label {
  font-size: 12px;
  font-weight: 700;
  color: #7aaa8d;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  display: block;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  height: 42px;
  border: 1px solid #c8dbd3;
  border-radius: 7px;
  padding: 0 14px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #1b3d2f;
  background: #f7fbf8;
  outline: none;
  transition: border-color 0.15s, background 0.15s;
}

.form-input:focus {
  border-color: #2d6a4f;
  background: #ffffff;
}

.btn-primary {
  width: 100%;
  height: 42px;
  border: none;
  border-radius: 7px;
  background: #1b3d2f;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-primary:hover {
  background: #2d6a4f;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1.25rem;
  padding: 0.65rem 1rem;
  border: 1px solid #c8dbd3;
  border-radius: 7px;
  background: #f7fbf8;
  color: #2c5542;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.btn-back:hover {
  background: #eef6ef;
  border-color: #a8c8b7;
}

.login-note {
  margin-top: 1.75rem;
  text-align: center;
  color: #5a6e62;
  font-size: 13px;
}

.login-note a {
  color: #1b3d2f;
  font-weight: 700;
  text-decoration: none;
}

.login-note a:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/NewUser.vue